import type { ReactNode } from 'react';

export const symbol_folder_delete: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h256q12.44 0 23.72 5t19.37 13.09L481-740h339q23 0 41.5 18.5T880-680v460q0 23-18.5 41.5T820-160H140Zm0-60h680v-460H456l-60-60H140v520Zm0 0v-520 520Zm410-60h120q20.83 0 35.42-14.58Q720-309.17 720-330v-205h15q10.83 0 17.92-7.12 7.08-7.11 7.08-18 0-10.88-7.08-17.88-7.09-7-17.92-7h-85v-20q0-6-4.5-10.5T635-620h-50q-6 0-10.5 4.5T570-605v20h-85q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7h15v205q0 20.83 14.58 35.42Q529.17-280 550-280Zm0-255h120v205H550v-205Z"
		/>
	</svg>
);
